import { render, staticRenderFns } from "./licencaPremioServidor.vue?vue&type=template&id=5e055304&scoped=true&"
import script from "./licencaPremioServidor.vue?vue&type=script&lang=js&"
export * from "./licencaPremioServidor.vue?vue&type=script&lang=js&"
import style0 from "./licencaPremioServidor.vue?vue&type=style&index=0&id=5e055304&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e055304",
  null
  
)

export default component.exports